import React, { useEffect, useRef, useState } from 'react';
import {
  EditorContainerRow,
  CustomJobHeadingText,
  DeleteConfirmationMessage
} from './styledComponents';
import {
  GridCell,
  GridTable,
  Label
} from '../NewEditorComponent/styledComponents';
import { notification } from 'antd';
import { reconvertJob } from '../../../Apis/Jobs';
import { formatDate } from '../../../Utils/dateFormat';
import QuillEditor from '../QuillEditor';
import { useSelector } from 'react-redux';
import ConfirmationModal from '../ConfirmationModal';
import Spinner from '../Spinner';
import WarningIcon from '../../../Assets/Icons/WarningIcon';
import { ItemsContainer } from '../../Content/Editor/styledComponents';
// import { getCptCodes } from '../../../Apis/Biller';

const NewBillerEditorComponent = props => {
  const editorRef = useRef(null);
  const [isHeading, setIsHeading] = useState(false);
  const [theme] = useSelector(state => [state.themeReducer]);
  const [revertJobModalVisible, setRevertJobModalVisible] = useState(false);

  useEffect(() => {
    if (props.saveStatus === 'Saved') {
      setTimeout(() => {
        props.setSaveStatus(null);
      }, 1000);
    }
  }, [props.saveStatus, props.loading]);

  // ✅ Revert Job API
  const revertJob = () => {
    props.setEditorLoading(true);
    reconvertJob(props.jobId)
      .then(response => {
        if (response.data.success) {
          for (let i = 0; i < response.data.result.length; i++) {
            const resultItem = response.data.result[i];
            for (let j = 0; j < resultItem.sections.length; j++) {
              const section = resultItem.sections[j];
              for (let k = 0; k < section.content.length; k++) {
                const contentItem = section.content[k];
                if (contentItem.type === 'Text') {
                  response.data.result[i].sections[j].content[k].value =
                    contentItem.value
                      .replace(/<\/p>/g, '</p>\n')
                      .replace(/<\/?p>/g, '');
                }
              }
            }
          }

          props.setSections(response.data.result[0]?.sections || []);
          props.setActiveSection(
            response.data.result[0]?.sections?.[0]?.id || null
          );
          props.setLastUpdateTime(response.data.result[0]?.lastUpdatedTime);
          props.setEditorLoading(false);
          setRevertJobModalVisible(false);
        } else {
          notification['error']({
            message: 'Section Fetch Failed',
            description: response.data.message
          });
          props.setEditorLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        props.setEditorLoading(false);
      });
  };

  return (
    <>
      <CustomJobHeadingText color={'#47A4EA'}></CustomJobHeadingText>
      <EditorContainerRow>
        <GridTable>
          {/* Patient Info */}
          <GridCell>
            <Label>Name</Label>
            <div style={{ fontWeight: 'bold', color: '#47A4EA' }}>
              {props.demographicsData?.find(d => d?.key === 'NAME')?.value ||
                '-'}
            </div>
          </GridCell>

          <GridCell>
            <Label>Room/Bed</Label>
            {props.patietSection?.[0]?.bedId}
          </GridCell>

          <GridCell>
            <Label>Date of Admission</Label>
            <div>{formatDate(props.patietSection?.[0]?.admissionDate, '-')}</div>
          </GridCell>

          <GridCell>
            <Label>Gender</Label>
            {props.demographicsData?.find(d => d?.key === 'GENDER')?.value ||
              '-'}
          </GridCell>

          <GridCell>
            <Label>DOB</Label>
            {formatDate(
              props.demographicsData?.find(d => d?.key === 'DATE OF BIRTH')
                ?.value,
              '-'
            )}
          </GridCell>

          <GridCell>
            <Label>Note Author</Label>
            <div>{props.printInfoData[0]?.author || '-'}</div>
          </GridCell>

          <GridCell>
            <Label>Facility</Label>
            <div>
              {props.printInfoData[0]?.facility?.facilityName
                ? props.printInfoData[0].facility.facilityName.slice(0, 20) +
                  (props.printInfoData[0].facility.facilityName.length > 20
                    ? '...'
                    : '')
                : '-'}
            </div>
          </GridCell>

          <GridCell>
            <Label>Date of Encounter</Label>
            {(() => {
              const visitDate = props.demographicsData?.find(
                d => d?.key === 'DATE OF VISIT'
              )?.value;

              if (!visitDate) return '-';

              return formatDate(visitDate, '-');
            })()}
          </GridCell>
          <GridCell>
            <Label>Template</Label>
            <div>{props.template || '-'}</div>
          </GridCell>

          <GridCell>
            <Label>Work Type</Label>
            {props.demographicsData?.find(d => d?.key === 'WORK TYPE')?.value ||
              '-'}
          </GridCell>
        </GridTable>

        {/* Editor */}
        {props.loading ? (
          <Spinner height='calc(100vh - 400px)' />
        ) : (
          <QuillEditor
            sections={props.sections}
            highlightWord={props.highlightWord}
            headings={props.headings}
            matchedCodes={props.matchedCodes}
            jobName={props.jobName}
            jobId={props.jobId}
            lastUpdateTime={props.lastUpdateTime}
            setLastUpdateTime={props.setLastUpdateTime}
            ref={editorRef}
            saveStatus={props.saveStatus}
            setSaveStatus={props.setSaveStatus}
            isHeading={isHeading}
            setIsHeading={setIsHeading}
            theme={theme}
            audioRef={props.audioRef}
            activeSection={props.activeSection}
            setActiveSection={props.setActiveSection}
            fetchContents={props.fetchContents}
            loading={props.loading}
            setEditorLoading={props.setEditorLoading}
            deleteSectionHandler={props.deleteSectionHandler}
            changeStatus={props.changeStatus}
            activeSectionContent={props.activeSectionContent}
            setActiveSectionContent={props.setActiveSectionContent}
            viewOnly={true}
            localSectionIdMap={props.localSectionIdMap}
          />
        )}
      </EditorContainerRow>

      <ConfirmationModal
        visible={revertJobModalVisible}
        onOk={() => revertJob()}
        onCancel={() => setRevertJobModalVisible(false)}
        loading={props.loading}
        confirmation={true}
        antdModalProps={{ closable: false }}
      >
        <WarningIcon />
        <DeleteConfirmationMessage>
          Are you sure you want to reconvert the dictation?
        </DeleteConfirmationMessage>
      </ConfirmationModal>
    </>
  );
};

export default NewBillerEditorComponent;
